import { handleRequest } from '_services';
import { normalize } from 'normalizr';
import { quickSearchResultsSchema, searchResult, userSearchResultsSchema, diagSearchResultsSchema } from '_services/_schemas';


export const searchService = {
    quickSearch,
    search,
    userSearch,
    diagSearch
};


async function quickSearch(searchStr) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/search/quick?searchStr=' + searchStr, requestOptions, true)
        .then(data => {
            var flat = normalize(data, quickSearchResultsSchema);
            return flat;
        });
}

async function search(searchStr, page, count) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/search/standard?searchStr=' + searchStr + '&page=' + page + '&resultCountRequested=' + count, requestOptions, true)
        .then(data => {
            var flat = normalize(data, { results: [searchResult] })
            return flat;
        });
}

async function userSearch(searchStr) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/search/user?searchStr=' + searchStr, requestOptions, true)
        .then(data => {
            var flat = normalize(data, userSearchResultsSchema);
            return flat;
        });
}


async function diagSearch(epno, searchStr, trtDiagSearch) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/search/diag?epno=' + epno + '&searchStr=' + searchStr + '&trtDiagSearch=' + trtDiagSearch, requestOptions, true)
        .then(data => {
            var flat = normalize(data, diagSearchResultsSchema);
            return flat;
        });
}
